module.exports = __webpack_public_path__ + "img/H1.dd3debf7.png";